/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "dog-b00e8d6c--sprite",
  "use": "dog-b00e8d6c--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"dog-b00e8d6c--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(310.648 20.322)\"><g transform=\"translate(-306 -19.621)\"><g transform=\"translate(0 0)\"><path d=\"M554.867,441.572a33.129,33.129,0,0,0,4,0v1a3.16,3.16,0,0,0-2,3,3,3,0,0,0,6,0,3.16,3.16,0,0,0-2-3v-2c.791-.183,1.21.255,2,0a42.016,42.016,0,0,0,8-4,71.294,71.294,0,0,1,2,13,.983.983,0,0,1-1,1h-16a.981.981,0,0,1-1-1c0-2.787-.349-5.553,0-8,.017-.119-.018.121,0,0Zm1-2c.26-1.508.628-3.271,1-5l-5,1a5.041,5.041,0,0,1-5-3l-1-3c-.2-.49.533-.755,1-1l10-6v-6c.066-.865,1.374-.6,2,0a40.72,40.72,0,0,1,10,14c.565,1.391.543,2.5,1,4-2.482,1.571-4.532,3.2-7,4a24.649,24.649,0,0,1-7,1Zm2-11c.709,0,1-1.291,1-2s-.291-1-1-1-1,.291-1,1S557.158,428.572,557.867,428.572Zm2,18a1,1,0,1,1,1-1A.981.981,0,0,1,559.867,446.572Z\" transform=\"translate(-546 -415.997)\" fill=\"currentColor\" /></g></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
